<template>
    <div id="listvideo">
        <div class="listvideobox">

            <el-table :data="listOFVideoInfor[0]" class="listvideobox" 
            style=" font-size: 16px"
            :row-style="{height:'35px', lineHeight:'35px'}"
            :cell-style="{padding:'0px'}"
            >
                <el-table-column prop="id" label="ID" width="65">
                </el-table-column>

                <el-table-column prop="title" width="210" show-overflow-tooltip>
                    <template slot="header" slot-scope="">
                        <div>
                            <span></span>
                            <i class="el-icon-postcard"></i>
                        </div>
                    </template>                    
                </el-table-column>

                <el-table-column prop="video" width="255">
                    <template slot="header" slot-scope="">
                        <div>
                            <span></span>
                            <i class="el-icon-video-camera"></i>
                        </div>
                    </template>   
                </el-table-column>

                <el-table-column prop="pic"  width="75"  show-overflow-tooltip>
                    <template slot="header" slot-scope="">
                        <div>
                            <span></span>
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </template>                      
                </el-table-column>      

                <el-table-column prop="time"  width="185">
                    <template slot="header" slot-scope="">
                        <div>
                            <span></span>
                            <i class="el-icon-time"></i>
                        </div>
                    </template>                      
                </el-table-column>  

                 <el-table-column prop="locked">
                    <template slot="header" slot-scope="">
                        <div>
                            <span></span>
                            <i class="el-icon-lock"></i>
                        </div>
                    </template> 
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.locked"
                        inactive-color="#939695"
                        active-color="#ff4949"
                        :inactive-value="0"
                        :active-value="1"
                        @change="changeLockedSwitch(scope.row)"
                        > 
                        </el-switch>
                    </template>
                </el-table-column>
                
                 <el-table-column prop="play">
                    <template slot="header" slot-scope="">
                        <div>
                            <span></span>
                            <i class="el-icon-video-play"></i>
                        </div>
                    </template> 
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.play"
                        inactive-color="#939695"
                        active-color="#67C23A"
                        :inactive-value="0"
                        :active-value="1"
                        @change="changePlaySwitch(scope.row)"
                        > 
                        </el-switch>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <template> 
                <div class="block">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage" 
                    :page-sizes="[20]" 
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="this.listOfAllVideoInfor[0].total_video">
                    </el-pagination>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { request } from '@/api/http';

export default {
    data () {
        return {
            listOfAllVideoInfor: [
                {
                    total_video: 0
                }
            ],
            listOFVideoInfor: [],

            currentPage: parseInt(this.$route.params.page),
        }
    },
    mounted () {
        this.getfirstvideopage();
    },
    methods: {
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);

            this.currentPage = val;
            
            this.$router.push({ name: 'listvideo', params: { page: val }});
        },

        //locked的开关
        changeLockedSwitch (data) {
            request('/CalawaEnServlet/VideoServlet', {
                action: 'updateVideo',
                id: data.id,
                locked: data.locked,
            }).catch(error=> {
                console.log(error);
            });
        },

        //play的开关
        changePlaySwitch (data) {
            request('/CalawaEnServlet/VideoServlet', {
                action: 'updateVideo',
                id: data.id,
                play: data.play,
            }).then(()=> {
                //延迟2s,后刷新页面，2s后可以保证看到switch的动画
                setTimeout(()=>history.go(0), 2000);
            }).catch(error=> {
                console.log(error);
            });
        },

        getfirstvideopage(){
            let page = this.$route.params.page;

            request('/CalawaEnServlet/VideoServlet', { action: 'getVideoList', page })
            .then(res=> {
                this.listOfAllVideoInfor = [res.data];
                this.listOFVideoInfor = [res.data.video_list];
            })
            .catch(error=> {
                console.log(error);
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>